const messageGetter = x => x.message;

export function defaultValidatorErrorsParser(errors) {
  console.log(errors);
  return Object.keys(errors).reduce((acc, x) => {
    acc[x] = errors[x].map(messageGetter);
    return acc;
  }, {});
}
